import { useCallback } from 'react'

import { Err, Result } from 'ts-results'

import { useApplication } from 'app/application/application'

import { HttpError, useHttp } from '../infrastructure'
import { ApiErrorResponse } from '../types'
import DataError from './dataError'

const handleApiResponse = <R>(
  result: Result<R, HttpError<ApiErrorResponse>>,
): Result<R, DataError<number>> =>
  result.ok
    ? result
    : Err(
        new DataError(
          result.val.code,
          result.val.payload?.messages[0].text ?? result.val.message,
          result.val,
        ),
      )

const useApi = () => {
  const { httpPost } = useHttp()
  const { authorization, setAuthorization } = useApplication()

  const create = useCallback(
    <T, R>(endpoint: string, data: T) =>
      httpPost<T, R, ApiErrorResponse>(endpoint, data).then((result) => {
        if (result.err && result.val.code === 401 && authorization) {
          setAuthorization({ state: 'expired' })

          // Translate 401 only in case of a former login
          return Err(new DataError(result.val.code, 'Session expired', result.val))
        }

        return handleApiResponse(result)
      }),
    [authorization, httpPost, setAuthorization],
  )

  return {
    create,
  }
}

export default useApi
